<template>
	<header class="container-fluid">
			<TenantSelect/>
		<div class="row">
			<div class="col-2 robo-logo">
				<div class="logo">
					<img src="../../assets/images/logo-robo.png" alt="Riding out board online">
				</div>
			</div>
			<div class="col-4">
				<div class="trial-container" v-if="trialDaysLeft > 0">
					<p><span>{{ trialDaysLeft }}</span> DAY{{ trialDaysLeft > 1 ? 'S' : '' }} LEFT ON YOUR TRIAL</p>
				</div>
				<div class="trial-container" v-if="subscriptionDaysLeft > 0">
					<p>YOUR SUBSCRIPTION EXPIRES IN <span>{{ subscriptionDaysLeft }}</span> DAY{{ subscriptionDaysLeft > 1 ? 'S' : '' }}</p>
				</div>
			</div>
			<div class="col-5">
				<div class="row account">
					<router-link class="account-link" to="/account" v-if="hasUserAccess">
						<i class="ss-user ss-glyphish-filled"></i>
						My Account
					</router-link>
					<button class="logout button-transparent" @click="logout" v-if="hasUserAccess">
						<i class="ss-lock ss-glyphish-filled"></i>
						Logout
					</button>
					<div class="tenant-logo" v-if="logoVisible">
						<img :src="tenant.logo" :alt="tenant.companyName" v-if="tenant && tenant.logo">
						<router-link to="/account" v-if="tenant && !tenant.logo && hasUserAccess">
							<div class="upload"><span>Upload<br>your logo<br>here</span></div>
						</router-link>
					</div>
				</div>
			</div>
			<div class="col-1 nav" v-if="hasUserAccess">
				<div @click="openNav" class="nav-btn">
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		</div>
		<div v-if="open" class="nav-menu">
			<button @click="openNav" class="close">X</button>
			<ul class="menu-links">
				<li><router-link to="/">Board</router-link></li>
				<li><router-link to="/horses">Horses</router-link></li>
				<li><router-link to="/people">People</router-link></li>
				<li><span>OPTIONS</span></li>
				<ul>
					<li><router-link to="/tasks">Tasks</router-link></li>
					<li><router-link to="/equipment">Equipment</router-link></li>
					<li><router-link to="/jobs">Jobs</router-link></li>
					<li><router-link to="/lots">Lots</router-link></li>
					<li><router-link to="/age">Age</router-link></li>
					<li v-if="tenant && tenant.hasMultiYard"><router-link to="/locations">LOCATIONS</router-link></li>
				</ul>
				<li><router-link to="/support">Support</router-link></li>
				<li v-if="hasAdminAccess"><router-link to="/plans">Plans</router-link></li>
			</ul>
		</div>
	</header>
</template>

<script>
import auth from '../lib/auth'
import VueRouter from 'vue-router'
import moment from 'moment'
import TenantSelect from './Header/TenantSelect';

export default {
	components: {
		TenantSelect
	},
	data() {
		return {
			open: false,
		}
	},
	methods: {
		openNav() {
			this.open = !this.open
		},
		logout() {
			auth.logout()
		},
	},
	computed: {
		tenant() {
			return this.$store.getters['tenant/get']
		},
		hasUserAccess() {
			return localStorage.getItem('userRole') && localStorage.getItem('userRole') !== 'view-only'
		},
		hasAdminAccess() {
			return localStorage.getItem('userRole') === 'admin' ? true : false
		},
		logoVisible() {
			return this.tenant && this.tenant.logo || this.hasUserAccess
		},
		trialDaysLeft() {
			if(this.tenant && this.tenant.trialEndDate) {
				const today = moment()
				const trialEndDate = moment(this.tenant.trialEndDate)

				return trialEndDate.diff(today, 'days')
			}
			return 0
		},
		subscriptionDaysLeft() {
			if(this.tenant && this.tenant.subscriptionExpired) {
				const today = moment()
				const subscriptionEndDate = moment(this.tenant.subscriptionExpired)

				return subscriptionEndDate.diff(today, 'days')
			}
			return 0
		}
	},
	watch: {
		'$route' (to, from) {
			this.open = false
		}
	}
}
</script>

<style lang="scss">
	@import "../scss/variables.scss";
	@import "../scss/mixins.scss";

	header {
		background-color: $brand-color;
		color: #ffff;
		height: 90px;
		padding-top: 20px;
		position: relative;
		.tenant-select {
			background-color: white;
			color: black;
			z-index: 1;
			position: absolute;
			width: 200px;
			top: 0;
			left: 200px;
		}
		.row {
			margin-left: 0px;
			margin-right: 0px;
		}
		.robo-logo {
			margin-top: -20px;
			padding-left: 30px;
			.logo {
				img {
					height: 85px;
					width: 85px;
				}
			}
		}
		a {
			color: #ffff;
			text-decoration: none;
		}
		p {
			margin-top: 20px;
		}
		.trial-container {
			margin-top: 15px;
			p {
				display: inline;
				border-radius: 16px;
				background-color: $warning-orange;
				padding: 8px 10px;
			}
		}
		.nav {
			.nav-btn {
				margin: 0 30% 0 auto;
				padding-top: 2px;
				height: 30px;
				width: 25px;
				div {
					margin-top: 10px;
					border-radius: 5px;
					width: 100%;
					height: 2px;
					background-color: #ffff;
					margin: 6px 0;
				}
			}
		}
		.nav-menu {
			position: fixed;
			background-color: $brand-color;
			opacity: 0.95;
			right:0px;
			top: 0px;
			height: 100vh;
			width: 400px;
			z-index: 9999;
			text-align: right;
			line-height: 44px;
			.close {
				border: none;
				background-color: Transparent;
				font-size: 35px;
				margin-right: 20px;
				margin-top: 20px;
				color: #ffff;
			}
			.menu-links {
				padding: 0;
				ul {
					padding-left: 80px;
					li {
						padding-left: 0px;
						a {
							font-size: 12px;
						}
					}
				}
				li {
					padding-top: 5px;
					padding-bottom: 5px;
					padding-left: 52px;
					text-align: left;
					border-bottom: 1px solid rgba(255, 255, 255, .17);;
					list-style-type: none;
					span {
						opacity: 0.50;
					}
					a {
						text-transform: uppercase;
						display: block;
						font-size: 14px;
						line-height: 44px;
						font-size: 14px;
						&:hover {
							opacity: 0.50;
						}
					}
				}
			}
			.button {
				margin-right: 30px;
			}
		}
		.account {
			justify-content: flex-end;
			.tenant-logo {
				box-shadow: 0 0 34px 0 rgba(0,0,0,0.15);
				margin-left: 20px;
				background-color: #fff;
				text-align: center;
				height: 125px;
				width: 125px !important;
				border-radius: 8px;
				padding: 10px;
				img {
					max-width: 100%;
					max-height: 100%;
				}
				a, a:hover, a:focus, a:visited {
					color: #009487
				}
				.upload {
					position: relative;
					height: 100%;
					span {
						position: absolute;
						top: 50%;
						left: 50%;
						margin-top: -26px;
						margin-left: -32.9px;
						display: block;
					}
				}
			}
			i {
				font-family: 'SSGlyphish-Outlined';
				display: inline;
				color: #ffff;
			}
			.logout {
				display: inline-block;
				margin-top: 20px;
				height: 20px;
				color: white;
				position: relative;
				padding-left: 20px;
				font-size: 14px;
				i {
					font-size: 14px !important;
					position: absolute;
					left: 0px;
					top: 0px;
				}
			}
			.account-link {
				display: inline-block;
				margin-top: 20px;
				height: 20px;
				color: white;
				position: relative;
				i {
					position: absolute;
					left: -25px;
					top: -2px;
				}
				&::after {
					padding-right: 10px;
					margin-left: 10px;
					content: "|";
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue